import { render } from "./BodyContentContainer.vue?vue&type=template&id=094b8b7c&scoped=true"
const script = {}

import "./BodyContentContainer.vue?vue&type=style&index=0&id=094b8b7c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-094b8b7c"

export default script